module.exports = __webpack_public_path__ + "img/linkedin_link_title.bcd01b4b.svg";